import { render, staticRenderFns } from "./Branch-office-header.vue?vue&type=template&id=5c041f99"
import script from "./Branch-office-header.vue?vue&type=script&lang=js"
export * from "./Branch-office-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports